import React, { useMemo } from 'react';
import { Box, Button, Divider, Typography } from '@mui/material';
import { useMeetingHubContext } from '../MeetingHubContext';
import Modal from 'components/shared/Modal';
import { ModalProps } from 'store/types/ComponentProps';
import { ActivityType } from 'store/enums/BallotReviewTypes';
import { getFormattedDate } from 'util/format';

const getConnectionEventLabel = (connectionStatus?: string) => {
  const normalizedStatus = connectionStatus?.toLowerCase();

  if (normalizedStatus?.includes('login')) {
    return 'logged in';
  }

  if (normalizedStatus?.includes('disconnect') || normalizedStatus?.includes('logout')) {
    return 'disconnected';
  }

  return connectionStatus ? connectionStatus.toLowerCase() : 'had a connection event';
};

const getDisplayName = (name?: string, company?: string) => {
  if (!company) {
    return name ?? '-';
  }

  return `${name ?? '-'} (${company})`;
};

const ConnectionLogModal: React.FunctionComponent<ModalProps> = ({ open, onClose }) => {
  const { activityLogs } = useMeetingHubContext();

  const logs = useMemo(
    () =>
      (activityLogs ?? [])
        .filter((log) => log.type === ActivityType.Connection)
        .sort((a, b) => new Date(b.occurredAt ?? '').getTime() - new Date(a.occurredAt ?? '').getTime()),
    [activityLogs]
  );

  return (
    <Modal
      title={'Connection Logs'}
      open={open}
      onClose={onClose}
      onSubmit={onClose}
      maxWidth={'sm'}
      actions={
        <Button type="submit" color={'secondary'} variant={'outlined'}>
          Close
        </Button>
      }
    >
      {!logs.length ? (
        <Typography>No connection events recorded yet.</Typography>
      ) : (
        <Box>
          {logs.map((log, index) => (
            <Box key={log.id} py={1}>
              <Typography>
                {getDisplayName(log.staffName, log.staffCompany)} {getConnectionEventLabel(log.connectionStatus)} at{' '}
                {getFormattedDate(log.occurredAt ?? '', 'L LT')}
              </Typography>

              {index < logs.length - 1 && <Divider sx={{ mt: 1 }} />}
            </Box>
          ))}
        </Box>
      )}
    </Modal>
  );
};

export default ConnectionLogModal;
